export default __webpack_public_path__ + "static/media/Slack.2022e631.svg";